import { helpers } from '../helpers.js';
import { filtering } from './filtering.js';


var tax = {
	selectors: {},
	addresses: [],

	init: function () {
		const self = this;

		self.loadProductsDatesData();
	},

	loadProductDates: function() {
		const self = this;

		jQuery( '.shop-date-products__contents a' ).on( 'click', function( event ){
			event.preventDefault();
		
			jQuery( '.shop-date-products__contents table' ).addClass( 'view-more' );
		});

		jQuery( '.js-openProductDates' ).on( 'click', function( event ){
			event.preventDefault();

			const product 	= jQuery( this ).closest( '.product' );
			
			const title 	= product.find( '.woocommerce-loop-product__title' ).text();
			const link 		= product.find( '.woocommerce-LoopProduct-link' ).attr( 'href' );
			const tbody 	= jQuery( '.shop-date-products__contents table tbody' );
			const dates 	= JSON.parse( product.find( '[data-product_dates]' ).attr( 'data-product_dates' ) );

			let soldOutDateButHaveMore = false;

			// console.log( dates );
			
			jQuery( '.shop-date-products__contents + p > a' ).attr( 'href', link );
			jQuery( '.shop-date-products__contents h3' ).text( title );
			jQuery( '.shop-date-products__contents table' ).removeClass( 'view-more' );
			tbody.html( '' );

			if( dates.length > 1 ) {
				jQuery.each( dates, function( index, event ) {
					if( index == 0 && event[ 'spots' ] > 0 ) {
						return; // break;
					}

					if( index > 0 && event[ 'spots' ] > 0 ) {
						soldOutDateButHaveMore = true;
						return; // break;
					}
				});
			}
            
            jQuery.each( dates, function( index, event ) {
				let text = event[ 'spots' ] == 0 ? `${pctVars.l18n.booking.state[1]}` : `${pctVars.l18n.booking.state[0]} ${event[ 'spots' ]}`;

				if( event[ 'spots' ] == 0 && soldOutDateButHaveMore ) {
					text = pctVars.l18n.booking.state[3]; 
				}

				if( ! event[ 'status' ] ) {
					text = pctVars.l18n.booking.state[2];
				}

				tbody.append( `<tr><td>${event.date_formatted} <br /><small>(${text})</small></tr>` );
            });

			jQuery.fancybox.open({
				src: '.shop-date-products',
				type : 'inline',
				touch: false,
			});
		});
	},

	loadProductsDatesData: function() {
		const self = this;
		let switchingListNode = document.querySelector('.switching-list');

		if( jQuery( '[data-product_dates="false"]' ).length == 0 ) {
			if (switchingListNode) {
				switchingListNode.dispatchEvent(
					new CustomEvent('switchingListFiltered')
				);
			}
			return false;
		}

		self.loadProductDates();

		let allProductIDs = [];
		let validProductsIDs = [];

		jQuery( '[data-product_dates="false"]' ).each(function( index ) {
			allProductIDs.push( parseInt( jQuery( this ).attr( 'data-product_id' ) ) );
		});

		helpers.pctApiCall({
			action: 'get_bookable_products_dates',
			post_ids: allProductIDs,
		}).then( response => {
			if( ! response.success ) {
				console.error( 'Error: ', response.data.message ); 
				return false;
			}

			Object.keys( response.data.data ).forEach( post_id => {
				let item = response.data.data[ post_id ];

				if( item === false ) {
					jQuery( `[data-product_id="${post_id}"]` ).closest( '.product' ).remove();
					return; // continue;
				}

				validProductsIDs.push( parseInt( post_id ) );

				// console.log( item );
				

				jQuery( `[data-product_id="${post_id}"]` ).closest( '.product' ).attr( 'data-event_date', item.event_date.join( ',' ) );
				// jQuery( `[data-product_id="${post_id}"]` ).closest( '.product' ).attr( 'data-limitedstart', item.limitedstart );
				jQuery( `[data-product_id="${post_id}"]` ).closest( '.product' ).attr( 'data-limitedend', item.limitedend );

				jQuery( `[data-product_id="${post_id}"]` ).removeClass( 'd-none' );
				jQuery( `[data-product_id="${post_id}"]` ).attr( 'data-product_dates', JSON.stringify( item.dates ) );

				let dateCounter = item.dates.length;
				let datesElement = jQuery( `[data-product_id="${post_id}"] .js-openProductDates` );
				let stockElement = jQuery( `[data-product_id="${post_id}"]` ).parent().find( '.stock' );
				let itemStockText  = '';

				if( dateCounter == 1 ) {
					//itemStockText = item.dates[0][ 'spots' ] == 0 ? `${pctVars.l18n.booking.state[1]}` : `${pctVars.l18n.booking.state[0]} ${item.dates[0][ 'spots' ]}`;

					if( ! item.dates[0][ 'status' ] ) {
						itemStockText = pctVars.l18n.booking.state[2];
					}

					datesElement.addClass( 'd-none' );
					stockElement.text( itemStockText );
					// jQuery( `[data-product_id="${post_id}"] > span` ).text( item.dates[0][ 'date_formatted' ] );

					return; // skip
				}

				let text = ( dateCounter > 4 ) ? pctVars.l18n.booking.terms[1] : pctVars.l18n.booking.terms[0];
				
				jQuery.each( item.dates, function(index, value) {
					//if( index == ( dateCounter - 1 ) || value[ 'spots' ] > 0 ) {

						//itemStockText = value[ 'spots' ] == 0 ? `${pctVars.l18n.booking.state[1]}` : `${pctVars.l18n.booking.state[0]} ${value[ 'spots' ]}`;

						if( ! value[ 'status' ] ) {
							itemStockText = pctVars.l18n.booking.state[2];
						}

						datesElement.text( `${dateCounter} ${text}` );
						stockElement.text( itemStockText );

						
						jQuery( `[data-product_id="${post_id}"] > span` ).text( value[ 'date_formatted' ] );
						
						
						return false; // skip all
					//}
				});				
			});

			allProductIDs.forEach( post_id => {
				if( validProductsIDs.includes( parseInt( post_id ) ) ) {
					return; // skip
				}

				jQuery( `[data-product_id="${post_id}"]` ).closest( '.product' ).remove();
				jQuery( `[data-product_id="${post_id}"]` ).closest( '.product:not( .product--persist )' ).remove();
			});

			if (document.querySelector('.js-allowProductsFilterByDates')) {
				let products = Array.from(document.querySelectorAll('li.product'));

				if( products.length ) {
					let filteredProducts = products.filter(product => {
						return product.hasAttribute('data-event_date');
					});
	
					filteredProducts.sort((a, b) => {
						let dateA = new Date(a.getAttribute('data-event_date').split(',')[0].split('-').reverse().join('-'));
						let dateB = new Date(b.getAttribute('data-event_date').split(',')[0].split('-').reverse().join('-'));
						return dateB - dateA;
					});
			
					let parent = products[0].parentNode;
					filteredProducts.forEach(product => {
						parent.insertBefore(product, parent.firstChild);
					});
				}
			}

			// const products = document.querySelectorAll('.js-allowProductsFilterByDates .products .product');
			// const urlParams = new URLSearchParams(window.location.search);
		
			// for (const [key, value] of urlParams.entries()) {
			// 	if (key.startsWith('f_') || key === 'start_date' || key === 'end_date' ) {
			// 		if( products.length ) {
			// 			products.forEach(product => {
			// 				if (!product.hasAttribute('data-event_date')) {
			// 					// console.log( product );
			// 					// console.log( product.getAttribute( "data-event_date" ) );
								
			// 					//product.remove();
			// 				}
			// 			});
			// 		}
			// 	}
			// }

			filtering.init();

			if ( jQuery('.js-allowProductsFilterByDates [data-loader]' ).length ) {
				jQuery('.js-allowProductsFilterByDates ul.products' ).closest( '[data-loader]' ).attr( 'data-loader', 'false' );
			}
			
			if ( jQuery('ul.products[data-loader]' ).length ) {
				jQuery('ul.products[data-loader]' ).attr( 'data-loader', 'false' );
			}
			
			if ( jQuery('.mini-tiles[data-loader]' ).length ) {
				jQuery('.mini-tiles[data-loader]' ).attr( 'data-loader', 'false' );
			}
		}).catch(error => {
			console.error( 'Error: ', error);
		}).finally(() => {
			if (switchingListNode) {
				switchingListNode.dispatchEvent(
					new CustomEvent('switchingListFiltered')
				);
			}
		});
	}
};

export { tax };